import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import cn from 'classnames'
import { changeTimer } from 'store/actions/call'
import { CallDirection } from 'common/Enums'
import { ReactComponent as AvailableIcon } from 'assets/svg/shared/available.svg'
import { useTranslation } from 'react-i18next'

import { Marquee } from 'components/shared'
import { visualNumberFormat } from 'utils/numberUtils'

const format = (time) => {
    let seconds = time % 60
    let minutes = Math.floor(time / 60)

    minutes = minutes.toString().length === 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length === 1 ? '0' + seconds : seconds

    return minutes + ':' + seconds
}

function CallStatusItem({ isTrying, isCalling, isTimerActive, isHold, isFinished, direction, timer, number }) {
    const [seconds, setSeconds] = useState(timer || 0)
    const dispatch = useDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        let interval = null
        let localSeconds = 0

        if (isTimerActive) {
            interval = setInterval(() => {
                setSeconds((seconds) => {
                    localSeconds = seconds + 1
                    return seconds + 1
                })
            }, 1000)
        } else if (!isTimerActive && seconds !== 0) {
            clearInterval(interval)
            dispatch(changeTimer({ number, seconds }))
        }
        return () => {
            interval && clearInterval(interval)
            dispatch(changeTimer({ number, seconds: localSeconds }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTimerActive])

    function renderCallStatus() {
        if (isFinished) {
            return t('call_status.finished')
        } else if (isTrying && direction === CallDirection.Outgoing) {
            return t('call_status.trying')
        } else if (isTrying && direction === CallDirection.Incoming) {
            return t('call_status.incoming')
        } else if (isCalling) {
            return t('call_status.calling')
        } else if (isHold) {
            return t('call_status.hold')
        } else if (isTimerActive) {
            return format(seconds)
        }
    }
    return (
        <span
            className={cn(
                'call__phone-status',
                isCalling && 'call__ringing',
                isHold && 'call__phone-status--hold',
                isTimerActive && 'call__ringing-timer'
            )}
        >
            {renderCallStatus()}
        </span>
    )
}

function CallInfoItem({ callInfo, isMultipleSession }) {
    const { isActive, isTrying, isCalling, isTimerActive, isHold, isFinished, direction, timer } = callInfo

    let { displayName, number } = callInfo
    number = visualNumberFormat(number)
    displayName = displayName === callInfo.number ? null : displayName
    const refHolder = useRef(null)

    return (
        <div className={cn('d-flex justify-content-between w-100', isHold && 'call--hold', 'call__holder')}>
            <span className={cn('call__phone-number call__phone-status', 'call__phone-number-long-number')}>
                <div
                    ref={refHolder}
                    className={`${
                        isMultipleSession && isActive ? 'call__phone-number-active' : ''
                    } call__phone-number-holder`}
                >
                    <Marquee
                        holderReference={refHolder}
                        wrapClass="ltr"
                        string={displayName ? `${displayName} ${number}` : number}
                    />
                </div>
            </span>
            {isMultipleSession && isActive && <AvailableIcon width={12} height={12} />}
            <CallStatusItem
                isTrying={isTrying}
                isCalling={isCalling}
                isTimerActive={isTimerActive}
                isHold={isHold}
                isFinished={isFinished}
                direction={direction}
                timer={timer}
                number={number}
            />
        </div>
    )
}

export function CallInfo(props) {
    const { callInfoNumbers: numbers } = props

    const isMultipleSession = numbers.filter((item) => !item.isFinished).length > 1

    return (
        <div className={cn('call__info-wrapper d-flex flex-column align-items-center w-100')}>
            {numbers.map((call) => (
                <CallInfoItem key={call.number} callInfo={call} isMultipleSession={isMultipleSession} />
            ))}
        </div>
    )
}
